import type { ReactNode } from 'react';
import { DefaultLayout } from 'layouts';

export type RouteType = {
  path: string;
  component: ReactNode;
  layout: ReactNode;
  middlewares: Array<ReactNode>;
  children?: Array<RouteType>;
};

export const makeRoute = ({
  path,
  component,
  layout = DefaultLayout,
  middlewares = [],
  children,
}: {
  path: string;
  component: ReactNode;
  layout?: ReactNode;
  middlewares?: Array<ReactNode>;
  children?: Array<RouteType>;
}): RouteType => ({
  path,
  component,
  layout,
  middlewares,
  children,
});
